<template>
  <v-dialog scrollable persistent
    v-model="config.status.active"
    :fullscreen="isPublished">
    <v-card v-if="!isPublished">
      <v-card-title class="primary pa-0">
        <v-toolbar flat color="transparent">
          <span>{{ `${printClientName} 様` }}</span>
          <v-spacer></v-spacer>
          <div class="d-flex align-center caption mr-2">
            <v-checkbox hide-details
              color="secondary"
              v-model="form.status.comments"
            />コメントを添付
          </div>
          <v-menu offset-y
            v-model="config.datepicker.issue"
            transition="scale-transition"
            min-width="290px"
            :close-on-content-click="false"
            :nudge-right="40">
            <template v-slot:activator="{ on }">
              <v-text-field readonly solo flat hide-details validate-on-blur
                v-on="on"
                v-model="printFormDate"
                prefix="発行日："
                color="primary"
                :rules="rules.required"
              />
            </template>
            <v-date-picker
              v-model="form.date"
              locale="ja"
              color="amber"
              :day-format="date => new Date(date).getUTCDate()"
              @input="config.datepicker.issue = false"
              @change="updateFileName"
            />
          </v-menu>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-tabs
          v-model="config.tab"
          background-color="blue-grey darken-4">
          <v-tab :class="{'white--text': config.tab !== 0}">内訳</v-tab>
          <v-tab v-if="form.status && form.status.comments" :class="{'white--text': config.tab !== 1}">コメント</v-tab>
          <v-tab>結果</v-tab>
        </v-tabs>
        <v-tabs-items
          v-model="config.tab">
          <v-tab-item>
            <v-list dense class="py-0">
              <v-list-item class="grey lighten-2">
                <v-list-item-content class="py-0">
                  <v-row dense>
                    <v-col cols="2" class="caption text-center blue-grey--text text--darken-4">指導日</v-col>
                    <v-col cols="2" class="caption text-center blue-grey--text text--darken-4">対応時間</v-col>
                    <v-col cols="1" class="caption text-center blue-grey--text text--darken-4">自習・待機</v-col>
                    <v-col cols="1" class="caption text-center blue-grey--text text--darken-4">指導時間</v-col>
                    <v-col cols="1" class="caption text-center blue-grey--text text--darken-4">担当</v-col>
                    <v-col cols="5" class="caption text-center blue-grey--text text--darken-4">備考</v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn icon disabled></v-btn>
                </v-list-item-action>
              </v-list-item>
              <template v-for="item in getEntryItems">
                <v-list-item :key="item.id">
                  <v-list-item-content class="py-0">
                    <v-row dense>
                      <v-col cols="2">
                        <v-text-field solo flat hide-details
                          class="caption"
                          v-model="item.date"
                        />
                      </v-col>
                      <v-divider vertical inset></v-divider>
                      <v-col cols="2">
                        <v-text-field solo flat hide-details
                          class="caption"
                          v-model="item.time"
                        />
                      </v-col>
                      <v-divider vertical inset></v-divider>
                      <v-col cols="1">
                        <v-text-field solo flat hide-details
                          class="caption"
                          v-model="item.breaktime"
                          @blur="verifyFloat({type: 'entries', name: 'breaktime', id: item.id }, updateEntryNumber)"
                        />
                      </v-col>
                      <v-divider vertical inset></v-divider>
                      <v-col cols="1">
                        <v-text-field solo flat hide-details
                          class="caption"
                          v-model="item.wage"
                          @blur="verifyFloat({type: 'entries', name: 'wage', id: item.id }, updateEntryNumber)"
                        />
                      </v-col>
                      <v-divider vertical inset></v-divider>
                      <v-col cols="1">
                        <v-select solo flat hide-details
                          class="caption"
                          v-model="item.aid"
                          :items="getTutorItems"
                        />
                      </v-col>
                      <v-divider vertical inset></v-divider>
                      <v-col>
                        <v-text-field solo flat hide-details
                          class="caption"
                          v-model="item.subject"
                        />
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action class="my-0">
                    <v-btn icon @click="removeItem('entries', item)">
                      <v-icon small color="red">fal fa-trash-alt</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="`${item.id}_div`"></v-divider>
              </template>
              <v-list-item>
                <v-row dense>
                  <div class="d-flex align-center">
                    <v-btn text
                      color="secondary"
                      @click="addItem('entries')">
                      <v-icon small class="mr-2">fal fa-plus</v-icon>
                      <span>追加する</span>
                    </v-btn>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="d-flex align-center">{{ `合計：${printTotalTutorNumber}時間` }}</div>
                </v-row>
              </v-list-item>
            </v-list>
            <v-subheader></v-subheader>
            <v-list>
              <v-list-item class="grey lighten-2">
                <v-list-item-content class="py-0">
                  <v-row dense>
                    <v-col cols="6" class="caption text-center blue-grey--text text--darken-4">名目</v-col>
                    <v-col cols="2" class="caption text-center blue-grey--text text--darken-4">数量</v-col>
                    <v-col cols="2" class="caption text-center blue-grey--text text--darken-4">単価</v-col>
                    <v-col cols="2" class="caption text-right font-weight-bold blue-grey--text text--darken-4">小計</v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action class="my-0">
                  <v-btn icon disabled></v-btn>
                </v-list-item-action>
              </v-list-item>
              <template v-for="(item, idx) in getItems">
                <v-list-item :key="item.id">
                  <v-list-item-content class="py-0">
                    <v-row dense>
                      <v-col cols="6">
                        <v-text-field solo flat hide-details
                          class="caption"
                          v-model="item.subject"
                          placeholder="名目"
                          :readonly="/*!idx*/false"
                        />
                      </v-col>
                      <v-divider vertical inset></v-divider>
                      <v-col cols="2">
                        <v-text-field solo flat
                          class="caption"
                          v-model="item.number"
                          placeholder="数量"
                          :hide-details="idx > 0 || item.number == printEntryNumber"
                          :readonly="/*!idx*/false"
                          :error-messages="item.number != printEntryNumber ? '一覧と異なる数量です' : ''"
                          @blur="verifyFloat({type: 'items', name: 'number', id: item.id })"
                        />
                      </v-col>
                      <v-divider vertical inset></v-divider>
                      <v-col cols="2">
                        <v-text-field solo flat hide-details
                          class="caption"
                          v-model="item.price"
                          placeholder="単価"
                          @blur="verifyInteger({type: 'items', name: 'price', id: item.id })"
                        />
                      </v-col>
                      <v-divider vertical inset></v-divider>
                      <v-col align-self="center" class="text-right">{{ `¥${parseFloat(item.number) * parseInt(item.price)}` }}</v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action class="my-0">
                    <v-btn icon :disabled="!idx" @click="removeItem('items', item)">
                      <v-icon small v-if="idx" color="red">fal fa-trash-alt</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="`${item.id}_div`"></v-divider>
              </template>
              <v-list-item>
                <v-row dense>
                  <div class="d-flex align-center">
                    <v-btn text
                      color="secondary"
                      @click="addItem('items')">
                      <v-icon small class="mr-2">fal fa-plus</v-icon>
                      <span>追加する</span>
                    </v-btn>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="d-flex align-center">{{ `消費税（10%）：¥${`${printSalesTax}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}` }}</div>
                </v-row>
              </v-list-item>
              <v-list-item>
                <v-row dense>
                  <v-spacer></v-spacer>
                  <div class="d-flex align-center font-weight-bold">{{ `合計：¥${`${printTotal}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}` }}</div>
                </v-row>
              </v-list-item>
            </v-list>
          </v-tab-item>
          <v-tab-item v-if="form.status && form.status.comments">
            <template v-for="item in getEntryItems">
              <v-subheader :key="`${item.id}_date`">{{ item.date }}</v-subheader>
              <v-textarea :key="`${item.id}_area`" outlined
                v-model="item.comment"
              />
            </template>
          </v-tab-item>
          <v-tab-item>
            <iframe :src="printSource" :style="printViewerHeight">
              <p>このデバイスではPDFのプレビュー機能をお使いになれません。</p>
            </iframe>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-text-field hide-details solo flat outlined
          class="mr-4"
          v-model="form.file"
          placeholder="ファイル名"
          prepend-inner-icon="fal fa-file-alt"
          suffix=".pdf"
        />
        <v-btn depressed
          color="secondary"
          :loading="isLoading"
          @click="publish">発行する</v-btn>
        <confirm ref="confirmer" />
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <v-card-title class="primary">{{ printPublishedTitle }}</v-card-title>
      <v-card-text>
        <v-container grid-list-md fill-height>
          <iframe :src="printPublishedUrl" style="display:block;border:none;width:100%;height:100%;" />
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import template from '@/assets/templates/tutor'
import confirm from '@/components/modals/confirm'
const DEF = {
  status: JSON.stringify({
    comments: true
  }),
  entries: JSON.stringify({
    id: '',
    date: '',
    time: '',
    breaktime: '',
    wage: '',
    subject: ''
  }),
  items: JSON.stringify({
    id: '',
    subject: '',
    number: '',
    price: ''
  })
}
export default {
  name: 'recordsBillModal',
  components: {
    confirm
  },
  data () {
    return {
      config: {
        tab: 0,
        status: {
          active: false,
          loading: false
        },
        datepicker: {
          issue: false
        }
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ]
      },
      form: {
        date: '',
        wage: '',
        file: '',
        status: JSON.parse(DEF.status),
        entries: [],
        items: []
      },
      store: {
        src: '',
        doc: {}
      }
    }
  },
  methods: {
    init: function (req) {
      console.log(req)
      const { entries } = req || {}
      const clientName = this.$store.getters['client/get']('name').join('')
      this.$set(this.config, 'tab', 0)
      this.$set(this, 'form', {
        file: `${clientName}_請求書（個別指導）_${this.$moment().format('YYYY年MM月DD日')}`,
        date: this.$moment().format('YYYY-MM-DD'),
        wage: '2000',
        status: JSON.parse(DEF.status),
        entries: (entries && entries.length) ? entries.map(it => {
          const { date, content, aid } = it
          const params = content ? JSON.parse(content) : {}
          return {
            id: this.$uuid(),
            date: date ? this.$moment(date).format('YYYY/MM/DD') : '',
            time: `${params.lesson.start}~${params.lesson.end}`,
            breaktime: '',
            // eslint-disable-next-line
            wage: params.wage ? params.wage.replace(/[０-９]/g, function(s) {
              return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
            }) : '',
            subject: `${params.subject || ''}・${params.topic}`,
            comment: params.comment || '',
            aid
          }
        }) : [],
        items: [ this.genItem('items', { subject: '個別指導', price: '2000' }) ]
      })
      this.$set(this.store, 'doc', {})
      this.updateEntryNumber()
    },
    publish: function () {
      const privateLesson = this.form.items[0]
      if (this.$refs.confirmer) {
        this.$refs.confirmer.open({
          title: '発行の確認',
          message: `個別指導（単価：¥${`${privateLesson.price}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}）で発行してもよろしいですか？`,
          callback: () => { this.submit({ type: 'publish' }) }
        })
      }
    },
    preSubmit: function (req) {
      const { type, file } = req
      const authors = this.$store.getters['config/get']('authors')
      const aid = this.$store.getters['author/get']('userid')
      const cid = this.$route.params.id || this.form.cid
      const mid = this.$store.getters['client/get']('lib').media
      const docData = {
        office: this.$store.getters['author/get']('belong'),
        client: {
          name: this.$store.getters['client/get']('name')
        },
        status: this.form.status,
        date: this.form.date,
        entries: this.form.entries,
        items: this.form.items,
        authors
      }
      const doc = type === 'publish' ? template.publish(docData) : {}

      const urls = {
        publish: `${this.$url.api}pdf/publish/${mid}`,
        post: `${this.$url.api}posts/insert/item/${cid}`,
      }
      const fds = {
        publish: {
          fileName: `${this.form.file}.pdf`,
          doc
        },
        post: {
          aid,
          title: this.form.file.replace(/_/g, ' '),
          content: `${this.$moment().format('YYYY年MM月DD日')}に発行しました。`,
          attachments: file ? [ file ] : []
        },
      }
      if (type && urls[type] && fds[type]) {
        this.$set(this.config.status, 'loading', true)
        return { type, url: urls[type], fd: fds[type] }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit(res.data.data)
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const socket = this.$store.getters['config/get']('socket')
      const { type, data } = req || {}
      if (type === 'publish') {
        console.log(data)
        this.$set(this.store, 'doc', data)
        this.$store.dispatch('notifier/addSSuccess', {
          title: this.form.file,
          message: '発行が完了しました。'
        })
        this.submit({ type: 'post', file: Object.assign(data, { extension: 'pdf' }) })
      } else if (type === 'post') {
        if (!socket.connected) {
          socket.connect()
        }
        socket.emit('POST_POST', req, (res) => {
          console.log(res)
        })
        this.$set(this.config.status, 'loading', false)
        // this.close()
      }
    },
    failSubmit: function (data) {
      const code = data && data.response && data.response.body.code
      const err = this.$error.box.file.upload[code] ? this.$error.box.file.upload[code] : ''
      if (err) {
        this.$store.dispatch('notifier/addAlert', {
          title: '発行失敗',
          message: err
        })
      }
      this.$set(this.config.status, 'loading', false)
    },
    open: function (req) {
      this.init(req)
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    genItem: function (type, req) {
      const uid = this.$uuid()
      return DEF[type] ? Object.assign(JSON.parse(DEF[type]), { id: uid }, req || {}) : null
    },
    addItem: function (type, req) {
      if (this.form[type]) {
        this.form[type].push(this.genItem(type))
      }
    },
    removeItem: function (type, req) {
      const { id } = req || { id: '' }
      if (this.form[type]) {
        const idx = this.form[type].findIndex(it => { return it.id === id })
        if (idx >= 0) {
          this.form[type].splice(idx, 1)
          this.updateEntryNumber()
        }
      }
    },
    verifyInteger: function (req, callback) {
      const { type, name, id } = req
      if (this.form[type]) {
        const idx = this.form[type].findIndex(it => { return it.id === id })
        if (idx >= 0) {
          const item = this.form[type][idx]
          // eslint-disable-next-line
          const sum = item[name] ? `${item[name]}`.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }).replace(/,/g, '') : '0'
          const val = isFinite(sum) ? `${parseInt(sum)}` : '0'
          this.$set(this.form[type][idx], name, val === '0' ? '' : val)
          if (typeof callback === 'function') {
            callback()
          }
        }
      }
    },
    verifyFloat: function (req, callback) {
      const { type, name, id } = req
      if (this.form[type]) {
        const idx = this.form[type].findIndex(it => { return it.id === id })
        if (idx >= 0) {
          const item = this.form[type][idx]
          // eslint-disable-next-line
          const sum = item[name] ? `${item[name]}`.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }).replace(/,/g, '') : '0'
          const val = isFinite(sum) ? `${parseFloat(sum).toFixed(2)}`.replace(/0+$/g, '').replace(/\.$/g, '') : '0'
          this.$set(this.form[type][idx], name, val === '0' ? '' : val)
          if (typeof callback === 'function') {
            callback()
          }
        }
      }
    },
    updateFileName: function () {
      const clientName = this.$store.getters['client/get']('name').join('')
      this.$set(this.form, 'file', `${clientName}_請求書（個別指導）_${this.$moment(this.form.date).format('YYYY年MM月DD日')}`)
    },
    updateEntryNumber: function () {
      const newNumber = this.getEntryNumber()
      this.$set(this.form.items[0], 'number', newNumber)
    },
    getEntryNumber: function () {
      return this.form.entries.length ? this.form.entries.reduce((prev, it) => {
        const { wage, breaktime } = {
          // eslint-disable-next-line
          wage: it.wage ? it.wage.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }) : '0',
          // eslint-disable-next-line
          breaktime: it.breaktime ? it.breaktime.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }) : '0'
        }
        return prev + (parseFloat(wage) - parseFloat(breaktime))
      }, 0) : 0
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isPublished () {
      return !!this.store.doc.id
    },
    printClientName () {
      const name = this.$store.getters['client/get']('name').join(' ')
      return (name === ' ') ? '' : name
    },
    printFormDate () {
      return this.$moment(this.form.date).format('YYYY年MM月DD日')
    },
    printTotal () {
      const total = this.form.items.length ? this.form.items.reduce((prev, it) => {
        const { price, number } = {
          price: it.price ? parseInt(it.price) : 0,
          number: it.number ? parseFloat(it.number) : 0
        }
        return prev + price * number
      }, 0) : 0
      return Math.round(total * 1.1)
    },
    printSalesTax () {
      const total = this.form.items.length ? this.form.items.reduce((prev, it) => {
        const { price, number } = {
          price: it.price ? parseInt(it.price) : 0,
          number: it.number ? parseFloat(it.number) : 0
        }
        return prev + price * number
      }, 0) : 0
      return Math.round(total * .1)
    },
    printTotalTutorNumber () {
      return this.form.entries.length ? this.form.entries.reduce((prev, it) => {
        const { wage, breaktime } = {
          // eslint-disable-next-line
          wage: it.wage ? it.wage.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }) : '0',
          // eslint-disable-next-line
          breaktime: it.breaktime ? it.breaktime.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }) : '0'
        }
        return prev + (parseFloat(wage) - parseFloat(breaktime))
      }, 0) : 0
    },
    printSource () {
      return this.store.src
    },
    printViewerHeight () {
      return `min-height:${window.innerHeight - 110}px;width:100%;`
    },
    printPublishedUrl () {
      return this.store.doc && this.store.doc.preview || ''
    },
    printPublishedTitle () {
      return this.store.doc && this.store.doc.name || ''
    },
    printEntryNumber () {
      return this.form.entries.length ? this.form.entries.reduce((prev, it) => {
        const { wage, breaktime } = {
          // eslint-disable-next-line
          wage: it.wage ? it.wage.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }) : '0',
          // eslint-disable-next-line
          breaktime: it.breaktime ? it.breaktime.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
          }) : '0'
        }
        return prev + (parseFloat(wage) - parseFloat(breaktime))
      }, 0) : 0
    },
    getEntryItems () {
      return this.form.entries.length ? this.form.entries.map(it => { return it }) : []
    },
    getItems () {
      return this.form.items.length ? this.form.items.map(it => { return it }) : []
    },
    getTutorItems () {
      const authors = this.$store.getters['config/get']('authors')
      return Object.keys(authors).filter(userid => {
        return authors[userid].roles.includes('tutor')
      }).map(userid => {
        return {
          value: userid,
          text: authors[userid].name[0]
        }
      })
    }
  }
}
</script>